import { Button } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import EntryTitle from '../../molecules/entry-title.component';
import { EntryType } from '../types';

interface EntryCompleteProp {
  entryType: EntryType,
}
export default function EntryComplete({
  entryType,
}: EntryCompleteProp) {
  const history = useHistory();

  const onGotoTop = () => {
    history.replace('/');
  }
  return (
    <>
      <div className="entry">
        {EntryTitle({entryType})}
        
        <div className="entry-complete">
          <div className="thanks">
  <pre>{`申し込みありがとうございました。

ご入力頂いたメールアドレスに申し込み完了のメールを自動送信致しましたのでご確認ください。

書類審査の後、今後の予定などについて担当者よりメールでご連絡させて頂きます。`}</pre>
          </div>

            <div className="entry-buttons">
              <Button
                type="button"
                className="entry-button"
                variant="contained"
                onClick={onGotoTop}
              >
                TOPへ
              </Button>
            </div>
        </div>
      </div>
    </>
  );
}